import { gql } from "gql";

export const SAVE_COMPANY_DOCUMENT = gql(/* GraphQL */ `
  mutation SaveCompanyDocument($document: CompanyDocumentInput!) {
    saveCompanyDocument(document: $document) {
      id
    }
  }
`);
